module.exports = __webpack_public_path__ + "ff6dda46f21b55027e409a99a5ffc613.svg";